import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { decryptAEStoString } from '../../utills/utilities';
import { ROUTES } from './url-constant';

const AdminProtectedRoute = ({ component }) => {
  let location = useLocation(),
    rawAccessToken = useSelector((state) => state?.accessToken?.value);
  const loggedUser = useSelector((state) => state?.loggedUser?.value);

  rawAccessToken = rawAccessToken
    ? decryptAEStoString(rawAccessToken)
    : rawAccessToken;

  if (!rawAccessToken) {
    return <Navigate to={ROUTES?.ADMINLOGINPAGE} state={{ from: location }} replace />
  }

  if (loggedUser?.loginAttempt == 0 && location.pathname !== ROUTES.FIRSTTIMECHANGESPASS && rawAccessToken) {
    return <Navigate to={ROUTES.FIRSTTIMECHANGESPASS} replace />;
  }
  // Otherwise, render the passed component
  return component;
}
export default AdminProtectedRoute;
